import React from 'react';
import { Link } from 'react-router-dom';
import './PraiseBreakPrivacy.css';

const PraiseBreakPrivacy: React.FC = () => {
  return (
    <div className="pb-privacy">
      <div className="container pb-privacy-inner">
        <Link to="/projects" className="pb-privacy-back">
          ← Projects
        </Link>
        <h1>Privacy policy</h1>
        <p className="pb-privacy-lead">How we handle information for Praise Break.</p>

        <section>
          <h2>Overview</h2>
          <p>
            This policy describes how Praise Break handles information when you use the Android app.
            Praise Break is made by jagoalt. It covers apps you choose so you can pause, pray, read a verse, or be still.
            The app does not require an account.
          </p>
        </section>

        <section>
          <h2>Information kept on your device</h2>
          <p>Settings and today&apos;s totals stay on your phone. Praise Break does not upload them to jagoalt servers.</p>
          <ul>
            <li>The apps you choose to watch</li>
            <li>Whether breaks are on, how often they appear, and how long they last</li>
            <li>Which break types you turned on, and the Bible version you picked</li>
            <li>A saved list of Bible versions, kept for up to a week</li>
            <li>How long watched apps have been open since the last break</li>
          </ul>
        </section>

        <section>
          <h2>Permissions</h2>
          <h3>Display over other apps</h3>
          <p>Praise Break uses this so a break can appear on top of another app. The break blocks that app until the timer ends.</p>
          <h3>Accessibility</h3>
          <p>
            Praise Break uses an accessibility service only to learn which app is open. It does not read what is on the
            screen, what you type, or the contents of other apps.
          </p>
          <h3>Usage access</h3>
          <p>Praise Break uses usage access to show how long apps were open today, including the circle on Today. Those times stay on your device.</p>
        </section>

        <section>
          <h2>Scripture</h2>
          <p>
            Verse text and the list of Bible versions are requested from YouVersion. The request identifies the app. It does
            not include your name, phone number, or an account. YouVersion may process those requests under its own privacy
            policy. The version you pick, and the downloaded version list, stay on your device.
          </p>
        </section>

        <section>
          <h2>Call and text</h2>
          <p>
            If you tap the phone or message icon, Praise Break opens your phone&apos;s own dialer or messages app to (501)
            351-0651. A text can include a short note you can edit before sending. Those calls and texts go through your
            carrier, not through jagoalt.
          </p>
        </section>

        <section>
          <h2>Information we do not collect</h2>
          <ul>
            <li>No account, name, email, or phone number is required to use the app</li>
            <li>The app does not include advertising or an analytics SDK</li>
            <li>The app does not read screen contents or messages in other apps</li>
          </ul>
        </section>

        <section>
          <h2>Deleting your data</h2>
          <p>
            Because this information stays on your device, uninstalling Praise Break removes it. We cannot recover or
            remotely delete that local data.
          </p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>
            Questions about this policy or your data can be sent through the{' '}
            <Link to="/contact">contact form</Link> on jagoalt.com.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PraiseBreakPrivacy;
